import { DatePipe } from '@angular/common';
import moment from 'moment';
import { localConfig } from 'src/app/config/Locale-config';

export enum DateSettings {
  YearMonthDay = 'yyyy/MM/dd',
  DayMonthYear = 'dd/MM/yyyy',
  MonthDayYear = 'MM/dd/yyyy',
  DayMonthYearLong = 'dd/MMM/yyyy',
  MonthDayYearLong = 'MMM/dd/yyyy',
}

export const COOKIE_DATE_FORMAT = 'user-date-format';

export const defaultTimeFormat = 'HH:mm';
// export const defaultGridDateFormat = 'yyyy/MM/dd';
// export const defaultGridDateFormatM = 'yyyy/MM/DD';
export const defaultDetailDateFormatShort = 'dd MMM';
export const defaultDetailDateFormatShortWithYear = 'DD MMM yyyy';
export const defaultDetailDateFormatLong = `${defaultDetailDateFormatShort} yyyy ${defaultTimeFormat}`;
export const defaultfilterFullDatetimeFormat = `yyyy-MM-dd HH:mm:ss`;
export const defaultfilterFullDatetimeFormatGMT = `yyyy-MM-dd HH:mm:ss z`;
export const defaultfilterFullDatetimeFormatTableGMT = `YYYY-MM-DD HH:mm:ss [GMT]Z`;

export function getDefaultDate(date: Date) {
  if (!date) {
    return '-';
  }
  return moment(date).format('yyyy-MM-DD');
}

export function parseDateByConfiguredLocal(date: Date, format = getGridDateFormat()) {
  const datePipe = new DatePipe(localConfig.ActualLocale);
  if (!date) {
    return '';
  }
  if (!format) {
    return getDefaultDate(date);
  }
  return datePipe.transform(date, format);
}

export function parseDateToBackEndFilters(date: Date) {
  return moment(date).format('YYYY-MM-DD');
}

export function getMonday(d) {
  d = new Date(d);
  const day = d.getDay();
  const diff = d.getDate() - day; // + (day === 0 ? -7 : 1); // adjust when day is sunday
  const newDate = new Date(d.setDate(diff));
  newDate.setHours(0, 0, 0);
  return newDate;
}

export function getLastDayOfWeek(startDayWeek: Date): Date {
  const endDate = new Date(startDayWeek);
  endDate.setDate(startDayWeek.getDate() + 6);
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}

export function getFirstDayOfMonth(date: Date): Date {
  const d = new Date(date);
  const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
  firstDay.setHours(0, 0, 0, 0);
  return firstDay;
}

export function getLastDayOfMonth(date: Date): Date {
  const d = new Date(date);
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0); // Día 0 del siguiente mes
  lastDay.setHours(23, 59, 59, 999); // Fin del día
  return lastDay;
}

export function createDateFromDateAndTime(date: Date, time: Date) {
  const combinedDate = new Date(date);
  combinedDate.setHours(time.getHours());
  combinedDate.setMinutes(time.getMinutes());
  return combinedDate;
}

export function avoidTimezone(dateToChange: Date) {
  const dateAbsolute = new Date(dateToChange.toUTCString());
  dateAbsolute.setHours(dateAbsolute.getHours() - dateAbsolute.getTimezoneOffset() / 60);
  return dateAbsolute;
}

export function setGridDateFormat(value: any) {
  localStorage.setItem(COOKIE_DATE_FORMAT, value);
}

export function getGridDateFormat() {
  let dateFormat = localStorage.getItem(COOKIE_DATE_FORMAT);
  if (!dateFormat) {
    dateFormat = DateSettings.YearMonthDay;
    setGridDateFormat(dateFormat);
  }
  return dateFormat;
}

export function getDateForm() {
  return DateSettings.YearMonthDay;
}

export function getGridDateFormatM() {
  const separator = '/';
  const dateFormat = getGridDateFormat();
  const parsedDateFormat = dateFormat.split(separator);
  return `${parsedDateFormat[0]}${separator}${parsedDateFormat[1]}${separator}${parsedDateFormat[2].toUpperCase()}`;
}

export function getGridDateFormatDateTime() {
  const separator = '/';
  const dateFormat = getGridDateFormat();
  const parsedDateFormat = dateFormat.split(separator);
  return `${parsedDateFormat[0]}${separator}${parsedDateFormat[1]}${separator}${parsedDateFormat[2].toUpperCase()} ${defaultTimeFormat}`;
}

export function setHourDate(date: Date, hour: number, minute: number) {
  const newDate = new Date(date);
  newDate.setHours(hour);
  newDate.setMinutes(minute);
  newDate.setSeconds(0);
  return newDate;
}

export function getUserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function formatDateToMidDay(date: Date): Date {
  const newDate = new Date(date);
  newDate.setHours(12, 0, 0, 0);
  return newDate;
}

export function formatDateNoTimezone(date: Date): string {
  // const fechaSinTimezone = date.toISOString().replace(/Z$/, '')
  const fechaSinTimezone = date.toString().replace(/Z$/, '');
  return fechaSinTimezone;
}
